import React from "react";

const RewardsInfoIcon = () => {
    return (
        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="23" height="22" fill="#F5F5F5" />
            <g id="My Account">
                <path
                    d="M-776 -1257C-776 -1258.1 -775.105 -1259 -774 -1259H19785C19786.1 -1259 19787 -1258.1 19787 -1257V1644C19787 1645.1 19786.1 1646 19785 1646H-774C-775.104 1646 -776 1645.1 -776 1644V-1257Z"
                    fill="white"
                />
                <path
                    d="M-774 -1258H19785V-1260H-774V-1258ZM19786 -1257V1644H19788V-1257H19786ZM19785 1645H-774V1647H19785V1645ZM-775 1644V-1257H-777V1644H-775ZM-774 1645C-774.552 1645 -775 1644.55 -775 1644H-777C-777 1645.66 -775.656 1647 -774 1647V1645ZM19786 1644C19786 1644.55 19785.6 1645 19785 1645V1647C19786.7 1647 19788 1645.66 19788 1644H19786ZM19785 -1258C19785.6 -1258 19786 -1257.55 19786 -1257H19788C19788 -1258.66 19786.7 -1260 19785 -1260V-1258ZM-774 -1260C-775.657 -1260 -777 -1258.66 -777 -1257H-775C-775 -1257.55 -774.552 -1258 -774 -1258V-1260Z"
                    fill="black"
                    fillOpacity="0.1"
                />
                <g id="ADI Rewards - My Account" clipPath="url(#clip0_220_7742)">
                    <rect width="1600" height="1857" transform="translate(-364 -695)" fill="#FDFEFF" />
                    <g id="Frame 113">
                        <rect width="1600" height="1855" transform="translate(-364 -695)" fill="#F7F7F7" />
                        <g id="Frame 113_2">
                            <g id="Rewards Dashboard">
                                <g id="Frame 7677">
                                    <g id="Loyalty / dashboard">
                                        <rect
                                            x="-284"
                                            y="-31"
                                            width="1440"
                                            height="84"
                                            rx="4"
                                            fill="url(#paint0_linear_220_7742)"
                                        />
                                        <g id="Frame 7678">
                                            <g id="Frame 7676">
                                                <g id="Frame 598">
                                                    <g id="icon information yellow">
                                                        <rect
                                                            id="Rectangle 279"
                                                            x="9.66699"
                                                            y="5.5"
                                                            width="3.66667"
                                                            height="11"
                                                            fill="white"
                                                        />
                                                        <path
                                                            id="Vector"
                                                            d="M21.1767 10.0167L12.484 1.32399C11.9413 0.781326 11.0604 0.781326 10.5177 1.32399L1.82497 10.0167C1.2823 10.5594 1.2823 11.4403 1.82497 11.983L10.5177 20.6757C11.0604 21.2184 11.9413 21.2184 12.484 20.6757L21.1767 11.983C21.7194 11.4403 21.7194 10.5603 21.1767 10.0167ZM12.417 15.5837H10.5837V13.7503H12.417V15.5837ZM12.417 11.917H10.5837V6.41699H12.417V11.917Z"
                                                            fill="#F8C411"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_220_7742"
                    x1="436"
                    y1="-22.81"
                    x2="436"
                    y2="53"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.170872" stopColor="#EBF1F7" />
                    <stop offset="1" stopColor="#E8EEF5" />
                </linearGradient>
                <clipPath id="clip0_220_7742">
                    <rect width="1600" height="1857" fill="white" transform="translate(-364 -695)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default RewardsInfoIcon;
